import * as React from "react";
import type { SVGProps } from "react";

const SvgEligibleProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    {...props}
  >
    <defs>
      <path id="eligible-products_svg__a" d="M0 0h20v20H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="eligible-products_svg__b" fill="#fff">
        <use xlinkHref="#eligible-products_svg__a" />
      </mask>
      <path
        fill="currentColor"
        d="M10 20c5.514 0 10-4.485 10-10 0-.951-.133-1.89-.396-2.788a.834.834 0 1 0-1.6.469c.218.746.33 1.526.33 2.319 0 4.595-3.739 8.334-8.334 8.334S1.667 14.594 1.667 10c0-4.595 3.738-8.333 8.333-8.333 1.67 0 3.276.488 4.646 1.41a.833.833 0 1 0 .932-1.38A9.94 9.94 0 0 0 10 0C4.486 0 0 4.486 0 10s4.486 10 10 10"
        mask="url(#eligible-products_svg__b)"
      />
      <path
        fill="currentColor"
        d="M18.577 1.91 10 10.489 7.255 7.744a.834.834 0 0 0-1.178 1.179l3.333 3.333a.83.83 0 0 0 1.18 0l9.165-9.166a.834.834 0 0 0-1.178-1.18"
      />
    </g>
  </svg>
);
export default SvgEligibleProducts;
